import { Grid } from "@mui/material";
import { useIntl } from "react-intl";

import { SelectInput } from "@dzambalaorg/mui-inputs-core";
import type { IPonziLeaderboardSearchDto } from "@framework/types";
import { TokenType } from "@framework/types";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";

import { SearchContractInput } from "../../../../../../components/inputs/search-contract";

interface IPonziLeaderboardSearchFormProps {
  initialValues: Partial<IPonziLeaderboardSearchDto>;
}

export const PonziLeaderboardSearchForm = (props: IPonziLeaderboardSearchFormProps) => {
  const { initialValues } = props;

  const { formatMessage } = useIntl();

  const { deposit, reward } = initialValues;
  const fixedValues = { deposit, reward };

  return (
    <SearchWithFilters initialValues={fixedValues as any}>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid size={{ xs: 6 }}>
          <SelectInput
            name="deposit.tokenType"
            options={TokenType}
            label={formatMessage({ id: "form.labels.deposit" })}
          />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <SelectInput
            name="reward.tokenType"
            options={TokenType}
            label={formatMessage({ id: "form.labels.reward" })}
          />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <SearchContractInput prefix="deposit" />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <SearchContractInput prefix="reward" />
        </Grid>
      </Grid>
    </SearchWithFilters>
  );
};
